import React from 'react';
import Link from 'react-router/lib/Link';
import AuthStore from '../reflux/stores/AuthStore';
import RaisedButton from 'material-ui/RaisedButton';
import Card from 'material-ui/svg-icons/action/credit-card';
import Back from 'material-ui/svg-icons/navigation/chevron-left';

export default class Expired extends React.Component {
    constructor(props) {
        super(props);

        this.handleAuth = this.handleAuth.bind(this);
    }


    
    componentWillMount() {
        let cliente = null;
        if (cliente = AuthStore.getCliente()) {
            if (cliente.suscripcion.days_left > 0)
                this.props.router.push('/');
        }
        this.unsusbscribe = AuthStore.listen(this.handleAuth);
    }

    componentWillUnmount() {
        this.unsusbscribe();
    }

    handleAuth(e, user) {
        console.log(user);
    }
    
    
    render() {
        return (
            <div className="container">

                    <div className="row">
                        <div className="col-xs-3">
                            <img src="public/images/sad-xxl.png" style={{display:'inline-block',maxWidth:100}} alt=""/>
                            <img src="public/images/sandclock.png" style={{display:'inline-block',maxWidth:100}} alt=""/>
                        </div>

                        <div className="col-xs-9">
                            <h2 style={{fontWeight:300}} className="">Su Suscripción ha vencido por lo que no puede crear mas comprobantes de retención. Le invitamos a renovar
                            su suscripción siguiendo este enlace:  
                            </h2>
                            <Link to="user/suscripcion"><RaisedButton label="Suscripción" primary={true}icon={<Card />} /></Link>
                        </div>
                    </div>
                    <br/><br/><br/><br/>
                    <div className="row">
                        <div className="col-xs-3">
                            <img src="public/images/happy-icon-0.png" style={{display:'inline-block',maxWidth:100}} alt=""/>
                            <img src="public/images/14-512.png" style={{display:'inline-block',maxWidth:100}} alt=""/>
                        </div>
                        
                        <div className="col-xs-9">
                            <h2 style={{fontWeight:300}} className="">
                                Adicionalmente puede regresar y realizar acciones como ver, editar o descargar comprobantes que ya haya creado.
                            </h2>
                            <Link to="/"><RaisedButton primary={true} label="regresar" icon={<Back />} /></Link>
                        </div>
                    </div>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./app-react/pages/Expired.jsx
 **/